module.exports = __webpack_public_path__ + "img/no-edge-filter-applied.5958652d.jpg";